/**
 * simple registry service
 * holds a registry with arbitrary data during the panel livetime (not reloaded)
 */

import {  Injectable } from '@angular/core';
import { has } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistryService {
  private registry: any = {};
  private subscriptions: any[] = [];




  /**
   * returns a value from the registry or returns the given default when key not present in registry
   * @param _key (string) - the unique key
   * @param _default (any) - the value that should be returned if not found in registry
   * @return any
   */
  get(_key: string, _default: any = undefined): any {
    if (has(this.registry, _key)) return this.registry[_key];
    return _default;
  }

  /**
   * subscribe to a value in the registry. Observer will be invoked once the value is not undefined or changed
   * @param _key (string) - the unique key
   * @return Observable<any>
   */
  subscribe(_key: string): Observable<any> {
    return new Observable((_observer) => {
      let compareValue: any = undefined;
      const interval = window.setInterval(() => {
          const val = this.get(_key);
          if ((val !== undefined && compareValue === undefined) || val !== compareValue) {
            _observer.next(val);
            compareValue = val;
          }
      }, 100);

      return () => {
        window.clearInterval(interval);
      };
    });
  }

  set(_key: string, _value: any) {
    this.registry[_key] = _value;
  }

  remove(_key: string) {
    if (has(this.registry, _key)) {
      delete this.registry[_key];
    }
  }

}
